import React, { useState, useId } from 'react';
import { InputGroupText, UncontrolledTooltip } from 'reactstrap';

const CurrencyIcon = ({style, isEditable, allowUndo = false, tooltipText, onClickUndo}) => {
  const [hovered, setHovered] = useState(false);
  const uid = useId();
  const spanId = `currencyIcon-${uid}`;

  return (
    <InputGroupText  
      onClick={() => {
        if (allowUndo && typeof onClickUndo === 'function') {
          onClickUndo();
        }
      }}    
      onMouseEnter={() => {
        if (allowUndo) {
          setHovered(true);
        }
      }}
      onMouseLeave={() => setHovered(false)}
      className={!isEditable ? "input-group-text-disabled" : ""}
      style={{ cursor: 'pointer', transition: 'all 0.3s ease', ...style }}
    >
      <span id={spanId}>
        {hovered ? (
          <i className="bi bi-arrow-counterclockwise"></i>
        ) : ( "£")}
      </span>
      {allowUndo && tooltipText &&
        <UncontrolledTooltip target={spanId} placement="top">
          {tooltipText || ""}
        </UncontrolledTooltip>
    }
    </InputGroupText>
  );
};

export default CurrencyIcon;
